import { useQuery } from "@tanstack/react-query";
import { message } from "antd";
import { PaginatedRequestParams } from "api";
import dayjs from "dayjs";
import { ReportApiService } from "features/report/api/report-api.services";
import { ReportViewItem } from "features/report/dashboard/report-viewItem"
import { SideBarFilterView } from "features/report/dashboard/sidebarFilter";
import { useEffect, useRef, useState } from "react";

export const SalesItemView = () => {
  const [reportType, setReportType] = useState(4); // default TAT
  const today = dayjs();
  const [entryTypeData, setEntryTypeId] = useState('')
  const [reportDataSelect, setReportTypeData] = useState('')
  const [GranularityId, setGranularity] = useState(1)
  const startOfPrevMonth = today.subtract(1, "month").startOf("month");
  const endOfPrevMonth = today.subtract(1, "month").endOf("month");

  const [state, setState] = useState({
    reportType: [],
    granularity: [],
    entryType: []
  } as any);
  const didFetch = useRef(false);
  const [materialId, setMaterialId] = useState<number | null>(null);
  const [isExcludeInSideVehicle, setIsExcludeInSideVehicle] = useState<boolean>(false);
  const inital = async () => {
    try {
      const [reportTypeRes, granularityRes, entryTypeRes] = await Promise.all([
        ReportApiService().getReportCommonList({ Flag: "ReportType", } as PaginatedRequestParams),
        ReportApiService().getReportCommonList({ Flag: "Granularity" } as PaginatedRequestParams),
        ReportApiService().getReportCommonList({ Flag: "ReportEntryType", Id: reportDataSelect } as PaginatedRequestParams),
      ]);
      setState({
        reportType: reportTypeRes,
        granularity: granularityRes,
        entryType: entryTypeRes,
      });
    } catch (error: any) {
      message.error(error);
    }
  };

  useEffect(() => {
    didFetch.current = true;
    setReportType(4);
    inital();
  }, [reportDataSelect]);

 const [filterTable, setFilterTable] = useState({
        ReportTypeId: 4,
        Page: 1,
        Size: 10
    } as any)

 const [filter, setFilter] = useState(() => {
  const baseFilter = {
    StartDate: startOfPrevMonth.format("YYYY-MM-DD"),
    EndDate: endOfPrevMonth.format("YYYY-MM-DD"),
    GarnularityId: 1, // default Month
    ReportTypeId: 4,
    MaterialId: materialId,
    Page: 1,
    Size: 10,
  } as any;

  if (isExcludeInSideVehicle && baseFilter.ReportTypeId !== 4) {
    baseFilter.IsExcludeInSideVehicle = isExcludeInSideVehicle;
  }

  return baseFilter;
});

  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs]>([
    startOfPrevMonth,
    endOfPrevMonth,
  ]);
  // const { data, isFetching } = useGetReportViewList(filter);
    const { getReportViewList, getReportTableData } = ReportApiService();
  
      const { isLoading:salesGraphLoading,data, isFetching,refetch:reportViewData } = useQuery(
          ["reportViewList", filter],
          () => getReportViewList(filter),
          { enabled: !!filter }
      );
  
      const { data: reporttable, isFetching: isreportFetching } = useQuery(
          ["commonReportTableList", filterTable],
          () => getReportTableData(filterTable),
          { enabled: !!filterTable }
      );




  return (
    <>
      <div style={{ display: "flex", height: "100%" }}>
        <div style={{ flex: 1 }}>
          <ReportViewItem
            data={data}
             isLoading ={salesGraphLoading}
            reportType={reportType}
            isFetching={isFetching}
            entryTypeId={entryTypeData}
            reporttable={reporttable?.res}
            isreportFetching={isreportFetching} 
             weightType=""            
            onRefresh={reportViewData} 
            setFilterTable={setFilterTable}
          />
        </div>

        <div
          style={{
            width: "300px",
            borderLeft: "1px solid #FFF0DD",
            padding: "16px",
            background: "#FFFFFF",
            marginTop: -18,
            marginRight: -18,
          }}
        >
          <SideBarFilterView
            data={state}
            filter={filter}
            setFilter={setFilter}
             setFilterTable={setFilterTable}
            ReportType={4}
            setReportTypeData={setReportTypeData}
            reportDataSelect={reportDataSelect}
            setEntryTypeId={setEntryTypeId}
            dateRange={dateRange}
            setDateRange={setDateRange}
            setGranularity={setGranularity}
            GarnularityId={GranularityId}
            setMaterialId={setMaterialId}
            materialId={materialId}
            setIsExcludeInSideVehicle={setIsExcludeInSideVehicle}
            isExcludeInSideVehicle={isExcludeInSideVehicle}
           
          />
        </div>
      </div>
    </>
  )
}